export default "__VITE_ASSET__Cb9f6FQH__"